import React, { useId } from 'react';
import { Box } from '@mui/material';

const FinnixProLogo = ({
  size = 52,
  width,
  height,
  title = 'FinnixPro logo',
  decorative = false,
  animated = false,
  variant = 'color',
  sx,
}) => {
  const id = useId().replace(/:/g, '');
  const shieldFillId = `finnixShieldFill-${id}`;
  const flowGlowId = `finnixFlowGlow-${id}`;
  const wavePathId = `finnixWavePath-${id}`;

  return (
    <Box
      sx={{
        width: width || size,
        height: height || size,
        flex: '0 0 auto',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <svg
        viewBox="10 0 44 46"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        style={{ display: 'block' }}
        role={decorative ? undefined : 'img'}
        aria-hidden={decorative ? 'true' : undefined}
        aria-label={decorative ? undefined : title}
      >
        <defs>
          <linearGradient id={shieldFillId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00BFA6" />
            <stop offset="100%" stopColor="#39CDBD" />
          </linearGradient>
          <radialGradient id={flowGlowId} cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#0A2E2E" stopOpacity="1" />
            <stop offset="100%" stopColor="#00BFA6" stopOpacity="0" />
          </radialGradient>
          <path id={wavePathId} d="M12 24c6-3 12-5 20-2s14 2 20-2" />
        </defs>
        <path
          d="M12 6c0-2.2 1.8-4 4-4h32c2.2 0 4 1.8 4 4v18c0 11-9 20-20 20S12 35 12 24V6z"
          fill={variant === 'monochrome' ? 'currentColor' : variant === 'reversed' ? '#ffffff' : `url(#${shieldFillId})`}
        />
        <path
          d="M12 24c6-3 12-5 20-2s14 2 20-2"
          stroke={variant === 'color' ? '#ffffff' : '#152326'}
          strokeWidth="1.8"
          fill="none"
          strokeLinecap="round"
        />
        <circle
          cx={32}
          cy={22}
          r="2.5"
          fill={`url(#${flowGlowId})`}
        >

        </circle>
      </svg>
    </Box>
  );
};

export default FinnixProLogo;
